@if (pageInfo$ | async; as pageInfo) {
  <gbc-page-header [pageInfo]="pageInfo">
  </gbc-page-header>
}

<ngx-datatable [rows]="rows$ | async" [columns]="columns" [rowClass]="getRowClass">
</ngx-datatable>
